// extracted by mini-css-extract-plugin
export default {"dateRangePicker":"DateRangePicker_dateRangePicker__Hw4Yc","text":"DateRangePicker_text__gdO68"};